// src/firebase.js
import { initializeApp } from "firebase/app";
// App Check imports désactivés temporairement (voir ci-dessous)
// import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey:            "AIzaSyAJI-5YNx6h7OtwFAQfIqMr8RyG6oDwtLs",
  authDomain:        "eniovote.firebaseapp.com",
  projectId:         "eniovote",
  storageBucket:     "eniovote.firebasestorage.app",
  messagingSenderId: "827712073016",
  appId:             "1:827712073016:web:9189e88fd684eb0a94e5cd",
};

// 1. Firebase app
const app = initializeApp(firebaseConfig);

// 2. App Check — DÉSACTIVÉ TEMPORAIREMENT
//    Cause identifiée : en mode incognito / onglet privé / première connexion
//    d'un utilisateur, le token reCAPTCHA v3 ne peut pas être obtenu assez vite
//    (pas de cookies tiers, pas de IndexedDB persistent). Résultat : Firestore
//    refuse toutes les requêtes → 0 délégués chargés → login impossible.
//
//    Impact sur la sécurité : faible à court terme. Les autres protections
//    restent actives (CSP, HSTS, rate limiting, Firestore rules, etc.).
//
//    Pour RÉACTIVER plus tard avec une configuration robuste, il faudrait :
//    - Passer en Firebase Auth (tokens persistants)
//    - OU configurer debug tokens pour les premiers accès
//    - OU utiliser App Check en mode non-enforcé (monitoring seulement)
//
// Code conservé pour référence :
// try {
//   initializeAppCheck(app, {
//     provider: new ReCaptchaV3Provider("6LfIkLksAAAAAlwrrdqUjjNUud4KNg69kFrDRjXI"),
//     isTokenAutoRefreshEnabled: true,
//   });
// } catch (e) { console.warn("[AppCheck] ⚠", e.message); }
console.log("[AppCheck] ⏸ Désactivé temporairement (fix connexion déconnectés)");

// 3. Firestore — LONG-POLLING FORCÉ pour garantir la connexion dans toutes les conditions
//    (firewalls entreprise, mode incognito, réseaux restrictifs, timing App Check, etc.)
//    experimentalForceLongPolling = true : utilise UNIQUEMENT HTTP long-polling
//    Plus robuste que auto-detect (qui essaie WebSocket en premier → peut timeout 10s)
//    Légèrement plus lent mais FIABLE à 100%.
//
// 3bis. CACHE LOCAL PERSISTANT (perf boot P2) — les onSnapshot servent d'abord
//    l'IndexedDB local (affichage immédiat aux relances) puis ne synchronisent
//    que les deltas. ORTHOGONAL au transport : le long-polling forcé reste
//    inchangé (contrainte fiabilité de connexion). persistentMultipleTabManager
//    car la PWA installée et des onglets navigateur peuvent coexister.
//    Kill-switch sans redéploiement : localStorage.aramis_fscache_off = "1"
//    (console : localStorage.setItem("aramis_fscache_off","1") puis recharger).
//    Repli automatique : si l'init avec cache échoue (IndexedDB indisponible —
//    incognito strict, WebKit capricieux), on retombe sur la config d'avant.
// 3ter. TRANSPORT AUTO-DÉTECTÉ EN OPT-IN (perf P3) — essai ENCADRÉ, poste par
//    poste : localStorage.aramis_transport_auto = "1" remplace le forçage par
//    experimentalAutoDetectLongPolling (WebChannel d'abord, repli long-poll
//    automatique). LE DÉFAUT NE CHANGE PAS : sans le flag, long-polling forcé
//    comme depuis toujours (contrainte fiabilité de connexion — réseaux
//    d'entreprise/incognito). Rollback : retirer le flag + recharger.
let _transportAuto = false;
try { _transportAuto = localStorage.getItem("aramis_transport_auto") === "1"; } catch { /* storage indispo */ }
if (_transportAuto) console.log("[Firestore] 🚀 Transport auto-détecté (essai opt-in aramis_transport_auto)");
const FS_SETTINGS = _transportAuto
  ? { experimentalAutoDetectLongPolling: true }
  : { experimentalForceLongPolling: true };
let _db;
let _fsCacheOff = false;
try { _fsCacheOff = localStorage.getItem("aramis_fscache_off") === "1"; } catch { /* storage indispo */ }
if (_fsCacheOff) {
  console.log("[Firestore] ⏸ Cache persistant désactivé (aramis_fscache_off)");
  _db = initializeFirestore(app, FS_SETTINGS);
} else {
  try {
    _db = initializeFirestore(app, {
      ...FS_SETTINGS,
      localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
    });
  } catch (e) {
    console.warn("[Firestore] Cache persistant indisponible, repli mémoire :", e?.message);
    _db = initializeFirestore(app, FS_SETTINGS);
  }
}
export const db = _db;

// Firebase Auth (App par défaut). Utilisé pour :
//   • salariés/managers (portail RH, Phase F/G) ;
//   • bascule d'identité vérifiée des délégués Aramis (custom token émis au
//     login → signInWithCustomToken → request.auth.uid vérifié côté CF).
export { app };
export const auth = getAuth(app);

// Exposer db globalement pour debug console (window.__db)
if (typeof window !== "undefined") {
  window.__FIREBASE_DB__ = db;
}

// ── Firebase Cloud Messaging (push notifications) ────────────────────────────
// `requestNotificationPermission` retiré le 30/09/2026 : sans appelant depuis le
// retrait de la fenêtre « Enio a besoin… ». Le lot push (jetons FCM, fonction
// d'envoi) demandera l'autorisation APRÈS un premier acte, pas au démarrage
// (impl8/spec-notifications.md §4).
